<div class="new-notification" *ngIf="newNotification">
  <app-notification
    [notification]="newNotification"
    [isNewNotification]="true"
    (action)="onCloseNewNotification(); clicked.emit()"
    (closeNewNotification)="onCloseNewNotification()"
  ></app-notification>
</div>
